import React from 'react';
import { IconLeft1 } from '@99designs/icons';
import { SubtleRouterLink, SubtleRouterLinkProps } from './SubtleRouterLink';

export function BackRouterLink({ children, ...props }: SubtleRouterLinkProps) {
    return (
        <SubtleRouterLink {...props}>
            <IconLeft1 />
            {children}
        </SubtleRouterLink>
    );
}
